import { useEffect, useState } from "react";
import DataTable from "../../component/DataTable";
import { Link } from "react-router-dom";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import { toast } from "react-toastify";
import AdminHeader from "../../component/AdminHeader";

const deleteEndpoint = ApiEndpoints.job.Delete;
const listEndpoint = ApiEndpoints.job.List;
const jobEditPath = "edit-jobpost";
const tableHeader = ["Date", "Job Title", "Type"];
const tbody = ["date", "title", "type"];

export default function JobPostingListing() {

  const [data, setData] = useState([]);


  const dataFetch = async () => {
    try {
      const response = await ApiRequest("GET", listEndpoint);
      const result = response.jobs;
      setData(result);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dataFetch();
  }, []);

  const handleDelete = async (job_id) => {
    const payload = { job_id };
    try {
      const response = await ApiRequest("POST", deleteEndpoint, payload);
      toast.success(response.message);
      dataFetch();
    } catch (error) {
      console.error(error);
    }
  };

  const pagename = {
    name: 'Job Management',
    user: 'Admin',
    innerpage: 'Job Management / Job Posting'
  }

  return (
    <>
      <AdminHeader pagename={pagename} />

      <div className="add-btn-section">
        <Link className="admin-add-btn" to="/add-jobpost">Add +</Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={jobEditPath}
          onDelete={handleDelete}
        />
      </div>

    </>
  )
}
